export const getPerformance = (): Performance | undefined =>
	typeof performance === 'undefined' ? undefined : performance;
